module.exports = __webpack_public_path__ + "img/retargeting.38aa840d.svg";